import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 100px 0px;
  text-align: center;
  font-family: 'Inter', sans-serif;
`